const mobileMQ = window.matchMedia("(max-width: 1024px)");

export class Breadcrumbs {
  private element: HTMLElement;
  private breadcrumbList: HTMLUListElement | null;
  private breadcrumbListItems: NodeListOf<HTMLLIElement> | null;
  private showAllBreadcrumbsButtonCreated: boolean = false;

  constructor(element: HTMLElement) {
    if (!!element) {
      this.element = element;
      this.breadcrumbList = this.element.querySelector(".breadcrumbs__list");
      this.breadcrumbListItems =
        this.breadcrumbList?.querySelectorAll("li") ?? null;
      this.init();
    }
  }

  private init() {
    this.handleResize();
  }

  private handleResize() {
    const resize = () => {
      this.handleBreadcrumbs();
    };
    mobileMQ.addEventListener("change", resize);
    resize();
  }

  private handleBreadcrumbs() {
    if (!mobileMQ.matches && this.breadcrumbListItems) {
      if (this.breadcrumbListItems.length > 2) {
        this.element.classList.add("breadcrumbs--truncated");
        this.createandHandleShowAllBreadcrumbButton();
        this.showAllBreadcrumbsButtonCreated = true;
      }
    }
  }
  private createandHandleShowAllBreadcrumbButton() {
    const showAllBreadcrumbs = document.createElement("BUTTON");
    showAllBreadcrumbs.classList.add("breadcrumbs-show-all");
    showAllBreadcrumbs.innerHTML = `
    <span class="visible-for-screen-readers">Show Full Breadcrumb List</span>
    …
    `;
    if (!this.showAllBreadcrumbsButtonCreated) {
      this.element.prepend(showAllBreadcrumbs);

      showAllBreadcrumbs.addEventListener("click", () => {
        this.element.classList.remove("breadcrumbs--truncated");
      });
    }
  }
}

export default function breadcrumbsInit() {
  const breadcrumbs = document.querySelector(".breadcrumbs") as HTMLElement;
  new Breadcrumbs(breadcrumbs);
}
